module.exports = __webpack_public_path__ + "static/img/constructnew1.a1c3406d.png";